export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: "action", name: "动作", icon: "ri-fire-line", description: "拳拳到肉的动作场面与热血追逐，感受肾上腺素飙升的观影快感。" },
  { slug: "romance", name: "爱情", icon: "ri-heart-3-line", description: "细腻动人的情感故事，记录相遇、错过与重逢的每一个瞬间。" },
  { slug: "scifi", name: "科幻", icon: "ri-planet-line", description: "从星际远征到赛博都市，用想象力构建未来世界的无限可能。" },
  { slug: "comedy", name: "喜剧", icon: "ri-emotion-happy-line", description: "轻松诙谐的节奏与笑点，为忙碌生活注入一份简单快乐。" },
  { slug: "mystery", name: "悬疑", icon: "ri-question-mark", description: "层层反转的谜题与线索，等待你在真相揭晓前先一步推理出答案。" },
  { slug: "animation", name: "动画", icon: "ri-palette-line", description: "天马行空的画风与温暖故事，适合全年龄观众一同欣赏。" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line", description: "安静而压抑的氛围营造，让恐惧在不知不觉中爬上脊背。" },
  { slug: "drama", name: "剧情", icon: "ri-book-open-line", description: "扎实的人物刻画与现实题材，讲述值得被认真对待的人生故事。" },
  { slug: "crime", name: "犯罪", icon: "ri-search-eye-line", description: "罪案侦破与人性的灰色地带，在正义与欲望之间反复拉扯。" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line", description: "魔法、冒险与异世界，带你走进超脱现实的瑰丽想象之中。" },
];

export const regions = ["中国", "美国", "韩国", "日本", "英国", "法国"];

export const yearsOptions = [
  { label: "全部年代", value: "all" },
  { label: "近 1 年", value: "1" },
  { label: "近 3 年", value: "3" },
  { label: "近 5 年", value: "5" },
];

export const sortOptions = [
  { label: "最新上线", value: "time" },
  { label: "最热人气", value: "heat" },
  { label: "评分最高", value: "rating" },
];